<ape-drawer
  [visible]="visible"
  [title]="TRANSLATION_KEYS.support.TITLE | translate"
  (visibleChange)="onVisibleChange($event)"
  (closeClick)="onVisibleChange(false)"
  [closable]="true"
>
  <div class="flex flex-col gap-6 text-gray-black pt-6 border-t border-gray-light">
    <div class="flex flex-col gap-1">
      <!-- Sottotitolo -->
      <h2 class="text-xl font-bold">
        {{ TRANSLATION_KEYS.support.SUBTITLE | translate }}
      </h2>

      <!-- Descrizione -->
      <p class="font-light">
        {{ TRANSLATION_KEYS.support.DESCRIPTION | translate }}
      </p>
    </div>

    <!-- Riferimenti per il supporto -->
    <div>
      <!-- Titolo -->
      <div class="flex items-center h-[54px] border-b border-gray-light font-bold">
        {{ TRANSLATION_KEYS.support.EMAIL_SECTION_TITLE | translate }}
      </div>

      <!-- Link -->
      <a
        class="flex items-center justify-between h-[54px] border-b border-gray-light relative"
        [href]="'mailto:' + (TRANSLATION_KEYS.support.SUPPORT_EMAIL | translate)"
        target="_blank"
      >
        <span>{{ TRANSLATION_KEYS.support.SUPPORT_EMAIL | translate }}</span>
        <span class="bg-button-primary rounded-[12px] size-8 flex items-center justify-center">
          <svg-icon
            src="assets/icons/send.svg"
            class="w-5 h-5 text-white"
            [applyClass]="true"
          />
        </span>
      </a>
    </div>

    <!-- Materiale formativo -->
    <div>
      <!-- Titolo -->
      <div class="flex items-center h-[54px] border-b border-gray-light font-bold">
        {{ TRANSLATION_KEYS.support.MATERIAL_SECTION_TITLE | translate }}
      </div>

      <!-- Link rows -->
      <a
        *ngFor="let link of materialLinksSection1; trackBy: trackByLinkUrl"
        class="flex items-center justify-between h-[54px] border-b border-gray-light relative"
        [href]="link.url"
        target="_blank"
      >
        <span>{{ link.label | translate }}</span>
        <span class="bg-button-primary rounded-[12px] size-8 flex items-center justify-center">
          <svg-icon
            src="assets/icons/chevron-right.svg"
            class="w-5 h-5 text-white"
            [applyClass]="true"
          />
        </span>
      </a>
    </div>

    <div *ngIf="isManager">
      <!-- Titolo -->
      <div class="flex items-center h-[54px] border-b border-gray-light font-bold">
        {{ TRANSLATION_KEYS.support.MATERIAL_SECTION_TITLE_2 | translate }}
      </div>

      <!-- Link rows -->
      <a
        *ngFor="let link of materialLinksSection2; trackBy: trackByLinkUrl"
        class="flex items-center justify-between h-[54px] border-b border-gray-light relative"
        [href]="link.url"
        target="_blank"
      >
        <span>{{ link.label | translate }}</span>
        <span class="bg-button-primary rounded-[12px] size-8 flex items-center justify-center">
          <svg-icon
            src="assets/icons/chevron-right.svg"
            class="w-5 h-5 text-white"
            [applyClass]="true"
          />
        </span>
      </a>
    </div>
  </div>
</ape-drawer>